@if (enableCalendarSync) {
	<div class="calendar-sync-section">
		<md-header size="xs" variant="semibold">Calendar Sync</md-header>
		<div class="calendar-sync-content">
			@if (calendarLoading()) {
				<lb-loader></lb-loader>
			} @else if (isSynced()) {
				<div class="token-active">
					<p>Your calendar sync is active. Choose your calendar app below, or copy the link to add it manually.</p>

					<div class="url-actions">
						<!-- <button md-button (click)="addToGoogleCalendar(calendarTokenStatus()?.url || '')">Google</button> -->
						<button md-button (click)="addToOutlookCalendar(calendarTokenStatus()?.url || '')">Outlook (Personal)</button>
						<button md-button (click)="addToOffice365Calendar(calendarTokenStatus()?.url || '')">Outlook (Work/School)</button>
						<button md-button (click)="copyToClipboard(calendarTokenStatus()?.url || '')">
							{{ linkCopied() ? 'Copied!' : 'Copy Link' }}
						</button>
					</div>

					<p class="expiration-text">Expires on {{ calendarTokenStatus()?.expiresDate | date: 'mediumDate' }}</p>

					<div class="token-actions">
						@if (isExpiringSoon()) {
							<button md-button (click)="renewCalendarToken()">Renew Sync</button>
						}
						<button md-button class="error-button" (click)="revokeCalendarToken()">Disable Sync</button>
					</div>
				</div>
			} @else {
				<div class="token-inactive">
					<p>Sync your lessons with your favorite calendar app (Google Calendar, Outlook, Apple Calendar).</p>
					<button md-button-brand (click)="generateCalendarToken()">Sync Calendar</button>
				</div>
			}
		</div>
	</div>
}
